import { createReducer } from '@reduxjs/toolkit'
import {
  CreateNewNoticeAction,
  CreateNewNoticeFailureAction,
  CreateNewNoticeSuccessAction,
  DeleteNoticeAction,
  DeleteNoticeFailureAction,
  DeleteNoticeSuccessAction,
  FetchNoticesAction,
  FetchNoticesFailureAction,
  FetchNoticesSuccessAction,
  MarkNoticeAsReadSuccessAction,
  ToggleCreateNoticeModalAction
} from './notices-actions'
import { type NoticesState } from './notices-types'

export const initialNoticesState: NoticesState = {
  loading: 0,
  notices: [],
  createNoticeModalOpen: false
}

export const noticesReducer = createReducer(initialNoticesState, builder => {
  // Regular-user-related actions //
  builder.addCase(FetchNoticesAction, (state, _action) => {
    state.loading += 1
  }).addCase(FetchNoticesSuccessAction, (state, action) => {
    state.loading -= 1
    state.notices = action.payload
  }).addCase(FetchNoticesFailureAction, (state, _action) => {
    state.loading -= 1
  }).addCase(MarkNoticeAsReadSuccessAction, (state, action) => {
    state.notices = state.notices.map(notice => {
      if (notice.id === action.payload.id) {
        return action.payload
      }
      return notice
    })
  })
  // Administrator-related actions //
    .addCase(CreateNewNoticeAction, (state, _action) => {
      state.loading += 1
    }).addCase(CreateNewNoticeSuccessAction, (state, action) => {
      state.loading -= 1
      state.createNoticeModalOpen = false
      state.notices.push(action.payload)
    }).addCase(CreateNewNoticeFailureAction, (state, _action) => {
      state.loading -= 1
    }).addCase(DeleteNoticeAction, (state, _action) => {
      state.loading += 1
    }).addCase(DeleteNoticeSuccessAction, (state, action) => {
      state.loading -= 1
      state.notices = state.notices.filter((notice) => notice.id !== action.payload)
    }).addCase(DeleteNoticeFailureAction, (state, _action) => {
      state.loading -= 1
    }).addCase(ToggleCreateNoticeModalAction, (state, _action) => {
      state.createNoticeModalOpen = !state.createNoticeModalOpen
    })
})
